import { render, staticRenderFns } from "./IDemoPicker.vue?vue&type=template&id=71a806a2&scoped=true&"
import script from "./IDemoPicker.vue?vue&type=script&lang=js&"
export * from "./IDemoPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a806a2",
  null
  
)

export default component.exports